import { CodeBlock } from '@customerio/pluma-components/react';
import { isEmptyString } from '@/utils/string';

type WebhookMessagePreviewProps = { body: string };

/** JSON bodies get syntax highlighting; anything else renders as plain text. */
function bodyLanguage(body: string): 'json' | 'plain' {
  if (isEmptyString(body)) {
    return 'plain';
  }
  try {
    JSON.parse(body);
    return 'json';
  } catch {
    return 'plain';
  }
}

/**
 * The webhook request body. The webhook response block (status label + attempts
 * table) is deferred (FPS-3194) — it needs `subjectSteps[].webhookResponse`, which isn't on
 * the delivery / detail wire yet (blocked on a subject-step data-layer ticket).
 */
export function WebhookMessagePreview({ body }: WebhookMessagePreviewProps) {
  return (
    <CodeBlock
      className="fs-mask"
      data-test-delivery-preview-webhook
      code={body}
      language={bodyLanguage(body)}
      withLineNumbers
    />
  );
}
